import type { LoopScope } from "../../../../../stores/automation/looping.store";
import type { PillNodeAttrs } from "@smartsuite/smartdoc/lib/esm/extensions/pill/extension";
import { t } from "i18next";
import { CURRENT_ITEM_OUTPUT_ID } from "../../../../../utils/constants";

export const createLoopItemPill = (
  looping: LoopScope,
): PillNodeAttrs | undefined => {
  const newOutputId = CURRENT_ITEM_OUTPUT_ID;

  if (looping.source && looping.source.oneofKind === "outputReference") {
    switch (looping.source.outputReference.source.oneofKind) {
      case "actionReference":
        return {
          icon: "",
          title: t("general.current-item"),
          value: JSON.stringify({
            value: {
              oneofKind: "outputReference",
              outputReference: {
                source: {
                  oneofKind: "actionReference",
                  actionReference:
                    looping.source.outputReference.source.actionReference,
                },
                outputId: newOutputId,
              },
            },
            target: "loop",
          }),
        };
      case "triggerReference":
        return {
          icon: "",
          title: t("general.current-item"),
          value: JSON.stringify({
            value: {
              oneofKind: "outputReference",
              outputReference: {
                source: {
                  oneofKind: "triggerReference",
                  triggerReference:
                    looping.source.outputReference.source.triggerReference,
                },
                outputId: newOutputId,
              },
            },
            target: "loop",
          }),
        };
      case "loopItem":
        throw new Error("Not implemented");
    }
  }
};
